// import Cookies from '@/fns/cookies';
import Cookies from 'js-cookie';

import eventNames from './events/names';
import initEvents from './events';

const COOKIE_CAPACITY = 'participants-ages';
const FIELD_CAPACITY = 'capacity';

const initCookies = ({instance, events}) => {

	const setParticipantsAges = participantsAges => {
		const cookie = JSON.stringify(participantsAges);
		Cookies.set(COOKIE_CAPACITY, cookie, {expires: 30});
		events.fire(eventNames.PARTICIPANTS_AGES);
	}

	const getParticipantsAges = () => {
		try {
			const cookie = Cookies.get(COOKIE_CAPACITY);
			const value = JSON.parse(cookie);
			return Array.isArray(value) ? value : getDefaultParticipantAges();
		} catch(e){
			return getDefaultParticipantAges();
		}
	}

	const getDefaultParticipantAges = () => {
		const adultAge = instance.options.adultAge;
		const defaultParticipantAges = instance.options.defaultParticipantAges || [adultAge, adultAge];
		return defaultParticipantAges;
	}
	
	const prepareParticipantsAgesWithCapacity = capacity => {
		const adultAge = instance.options.adultAge;
		const participantsAges = getParticipantsAges();
	
		if(participantsAges.length > capacity){
			participantsAges.splice(capacity);
		}else 
	
		if(participantsAges.length < capacity){
			const addParticipants = [...Array(capacity - participantsAges.length)].map(() => adultAge);
			participantsAges.push(...addParticipants);
		}
	
		return participantsAges;
	}

	const restore = () => {
		let participantsAges = getParticipantsAges();
		if(participantsAges.length === 0){
			const adultAge = instance.options.adultAge;
			participantsAges = getDefaultParticipantAges();
			setParticipantsAges(participantsAges);
		}
		const {id} = instance.options.fields[FIELD_CAPACITY].find(({value}) => value === participantsAges.length);
		instance.store.setFieldValue(FIELD_CAPACITY, id);
	}

	const updateCookie = () => {
		const criteriaId = instance.store.getFieldValue(FIELD_CAPACITY);
		if(!criteriaId){
			// const adultAge = instance.options.adultAge;
			// setParticipantsAges([adultAge, adultAge]);
			setParticipantsAges([]);
			return;
		}
		const {value: capacity} = instance.options.fields[FIELD_CAPACITY].find(({id}) => id === criteriaId);
		const participantsAges = getParticipantsAges();
		if(capacity !== participantsAges.length){
			const newParticipantsAges = prepareParticipantsAgesWithCapacity(capacity);
			setParticipantsAges(newParticipantsAges);
		}
	}

	
	let syncState = false;
	instance.store.onFieldValue(FIELD_CAPACITY, () => syncState && updateCookie(), true);
	
	const sync = _syncState => syncState = _syncState;
	

	return {
		restore,
		sync,
		getParticipantsAges,
		setParticipantsAges,
	}
}

const preInitCookies = instance => {
	const events = initEvents(instance);
	return {
		eventNames,
		events,
		init: () => initCookies({instance, events}),
	}
}

export default preInitCookies;